import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../interfaces/form';
import { AccessService } from 'src/app/services/access.services';
import { NzModalService } from 'ng-zorro-antd';
import { KryptoService } from 'src/app/services/krypto.service';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-form-data-krypto',
  templateUrl: './form-data-krypto.component.html',
  styleUrls: ['./form-data-krypto.component.scss']
})
export class FormDataKryptoComponent implements OnChanges, OnDestroy {

  @Output() onSubmitForm = new EventEmitter<any>();
  @Input() settingsForm: FormField[] = [];
  @Input() formKrypto: FormGroup;
  @Input() idKrypto: string;
  @Input() krypto: any;
  @Input() isEditMode: boolean = false;
  @Input() keyId: number;

  passwordVisible = false;
  password?: string;
  passwordGuest?: string;
  isVisible = false;
  isVisibleTokenModal = false;
  passwordExists = false;
  emailExists = false;
  isSameEmail: boolean = false;
  public user: any = null;
  public ud: any;
  custodios: { email: string; isPrincipal: boolean, status: number, order: number, passwordGuest: string }[] = [];
  inputEmail: string = '';
  isValidEmail: boolean = false;
  temporaryEmail: string = '';
  protected isOkLoading = false;
  protected otpControl = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
  form: FormGroup = new FormGroup({});
  private destroy$ = new Subject<void>();

  constructor(
    private accessService: AccessService,
    private nzModalService: NzModalService,
    private kryptoService: KryptoService,
    private loaderService: LoaderService,
    private aR: ActivatedRoute
  ) {
    const storedUser = sessionStorage.getItem('ud');
    if (storedUser) {
      this.ud = JSON.parse(storedUser);
      this.user = this.ud.userDetails;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.krypto) {
      this.checkEmails();
      this.setForm();
      this.showCustodios();
    }
  }

  checkEmails(): void {
    const keyCustodios = this.krypto?.data?.keyCustodios;

    if (!keyCustodios || keyCustodios.length === 0) {
      this.isSameEmail = true;
      return;
    }

    const emailKrypto = keyCustodios[0]?.whitelistCustodio?.email;
    const isPrincipal = keyCustodios[0]?.isPrincipal;
    const emailLocalStorage = this.user?.email;

    this.isSameEmail = emailKrypto === emailLocalStorage && isPrincipal === true;
  }

  createForm() {
    this.form = new FormGroup({});
    this.settingsForm.forEach(field => {
      this.form.addControl(field.formControlName, new FormControl({ value: field.value, disabled: field.disabled }, field.validations));
    })
  }

  setForm() {
    this.formKrypto.setValue({
      description: this.krypto.data.description,
      usage: this.krypto.data.usage,
      expirationDate: this.krypto.data.expirationDate,
    });

    if (!this.isSameEmail) {
      this.formKrypto.get('description').disable();
      this.formKrypto.get('usage').disable();
      this.formKrypto.get('expirationDate').disable();
    } else {
      this.formKrypto.get('description').enable();
      this.formKrypto.get('usage').enable();
      this.formKrypto.get('expirationDate').enable();
    }
  }

  getErrors(c: AbstractControl) {
    const formGroup = c.parent.controls;
    const control = Object.keys(formGroup).find(name => c === formGroup[name]) || null;
    return this.settingsForm.find(field => field.formControlName === control).errors || [];
  }

  getDataValue(optionValue: string, data) {
    if (optionValue && data) {
      return data[optionValue]
    }
    if (data.value) {
      return data.value;
    }
    return data;
  }

  getLabelValue(optionValue: string, data) {
    if (optionValue && data) {
      return data[optionValue]
    }
    if (data.name) {
      return data.name;
    }
    return data;
  }

  showModal(): void {
    this.isVisible = true;
  }

  showModalToken(): void {
    this.isVisible = false;
    this.isVisibleTokenModal = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  handleCancelToken(): void {
    this.isVisibleTokenModal = false;
    this.temporaryEmail = '';
  }

  savePassword(): void {
    this.passwordExists = true;
    this.submitForm();
  }

  savePasswordGuest(password: string): void {
    this.kryptoService.generatePartialKey(this.idKrypto, password).subscribe(
      () => {
        this.passwordGuest = '';
        this.fetchKryptoData();
      }
    )
  }


  submitForm(): void {
    if (this.formKrypto.invalid) {
      return;
    }
    const rawData = this.formKrypto.getRawValue();

    const data = {
      Description: rawData.description,
      Usage: rawData.usage,
      ExpirationDate: rawData.expirationDate,
      Password: this.password,
    };

    this.onSubmitForm.emit(data);
  }

  validateEmail(): void {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.isValidEmail = emailPattern.test(this.inputEmail?.trim() || '');
  }

  submitEmail(): void {
    this.kryptoService.validateCustodio(this.inputEmail.trim()).subscribe(
      () => {
        this.isVisible = false;
        this.isVisibleTokenModal = true;
      }
    );
  }


  handleOkToken(): void {
    const userData = sessionStorage.getItem('ud');
    this.ud = userData ? JSON.parse(userData) : null;
    const id = this.ud?.userDetails?.id;
    this.accessService.validateAuthToken(this.otpControl.value, id).subscribe((res: any) => {
      this.checkEmails();
      this.keyId = this.keyId ?? Number(this.aR.snapshot.paramMap.get('id'));
      this.assingKey(this.inputEmail, this.keyId);
      this.isVisibleTokenModal = false;
      this.emailExists = true;
      this.inputEmail = '';
      sessionStorage.setItem('ud', JSON.stringify(this.ud));
    }, () => {
      this.otpControl.reset();
      this.error('Token incorreto');
    })
  }

  assingKey(email: string, key: number) {
    this.loaderService.updateLoading(true);
    this.kryptoService.assingKey(email, key).subscribe(
      (response) => {
        this.loaderService.updateLoading(false);
        this.nzModalService.success({ nzTitle: "Se registro custodio." });
        this.custodios.push({
          email: email,
          isPrincipal: false,
          status: 2,
          order: null,
          passwordGuest: ''
        });
      }, (error) => {
        this.loaderService.updateLoading(false);
      }
    )
  }

  showCustodios(): void {
    if (!this.krypto?.data?.keyCustodios) {
      return;
    }
    this.custodios = this.krypto.data.keyCustodios.map(custodio => ({
      email: custodio.whitelistCustodio.email,
      isPrincipal: custodio.isPrincipal,
      status: custodio.status,
      order: custodio.order
    })).sort((a, b) => a.order - b.order);
  }

  fetchKryptoData(): void {
    this.kryptoService.keyById(this.idKrypto).subscribe(
      (response) => {
        this.krypto = response;
        this.showCustodios();
      },
      (error) => {
        this.error("Error al obtener los datos actualizados de krypto")
      }
    );
  }

  generateKey() {
    this.kryptoService.generateKey(this.idKrypto).subscribe((response) => {
      this.nzModalService.success({ nzTitle: "Se genero la llave." });
      this.krypto.data.status = 1;
    },
      (error) => {
        this.error("Error al generar llave.")
      }
    )
  }

  get canGenerateKeys(): boolean {
    if (!this.krypto?.data?.keyCustodios) {
      return false;
    }

    if (this.krypto.data.status === 1) {
      return false;
    }

    if (this.krypto.data.keyCustodios.length < 2) {
      return false;
    }

    const hasStatus2 = this.krypto.data.keyCustodios.some(c => c.status === 2);
    if (hasStatus2) {
      return false;
    }

    const allStatus1 = this.krypto.data.keyCustodios.every(c => c.status === 1);

    return allStatus1 && this.isSameEmail;
  }

  get InputPassword(): (email: string) => boolean {
    return (email: string) => {
      const emailLocalStorage = this.user?.email;
      return email === emailLocalStorage;
    };
  }

  disablePastDates = (current: Date): boolean => {
    return current < new Date();
  };

  error(error): void {
    this.nzModalService.error({ nzTitle: 'Mensaje de error', nzContent: error });
  }

  get isAddCustodiosDisabled(): boolean {
    const isInvalidCredentials = !this.passwordExists && this.isSameEmail === false;
    if (isInvalidCredentials) {
      return false;
    }
    if (!this.krypto?.data?.keyCustodios) {
      return true;
    }

    if (this.krypto.data.status === 2) {
      return true;
    }

    if (this.krypto.data.status === 1) {
      return false;
    }

    return false;
  }
}
